import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

const createaQueryString = (query) => {
    return `?${Object.keys(query)
        .map((el) => `${el}=${query[el]}`)
        .join('&')}`;
};

export const getIRLetterList = async (query) => {
    const endPoint = `ir/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const getNewsList = async (query) => {
    const endPoint = `news/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const getNoticeList = async (query) => {
    const endPoint = `notice/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};
export const getSeminarList = async (query) => {
    const endPoint = `seminar/list`;
    let queryString = createaQueryString(query);
    if (!query.date) queryString = `?date=${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`;

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const postSeminarReq = async (data) => {
    const endPoint = `seminar/request/insertAction`;
    const result = await instance.post(endPoint, data);
    return result;
};

export const postSeminarUpdate = async (data) => {
    const endPoint = `seminar/request/update`;
    const result = await instance.post(endPoint, data);
    return result;
};

export const postSEminarDetail = async (data) => {
    const endPoint = `seminar/request/detail`;
    try {
        const result = await instance.post(endPoint, data);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const seminarRequestCancel = async (data) => {
    const endPoint = `seminar/request/requestCancel`;
    try {
        const result = await instance.post(endPoint, data);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const getRecruitList = async (query) => {
    const endPoint = `recruit/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};
export const getRecruitNoticeList = async (query) => {
    const endPoint = `recruit/notice/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const getElectronicList = async (query) => {
    const endPoint = `electronic/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const getBridgingActivity = async (query) => {
    const endPoint = `bridging/activity/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const getPopupList = async (query) => {
    const endPoint = `popup/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const getMainInfo = async (param) => {
    const endPoint = `/main/${param}/info`;

    try {
        const result = await instance.get(endPoint);
        return result.data || {};
    } catch (err) {
        return {};
    }
};
export const getPrivacyList = async (param) => {
    const endPoint = `/policy/${param}/list`;

    try {
        const result = await instance.get(endPoint);
        return result.data || {};
    } catch (err) {
        return {};
    }
};
export const getBridgingIntroduce = async () => {
    const endPoint = `bridging/introduce/list`;

    try {
        const result = await instance.get(endPoint);
        return result.data || {};
    } catch (err) {
        return {};
    }
};
export const getAboutIntroduce = async () => {
    const endPoint = `about/list`;

    try {
        const result = await instance.get(endPoint);
        return result.data || {};
    } catch (err) {
        return {};
    }
};

// export const getBridgingIntroduce = async (page = 1) => {
//     return await instance.get(`bridging/introduce/list?page=${page}`);
// };

export const getDownloadCategory = async (query) => {
    try {
        const result = {};

        const {
            data: { list: mainCate },
        } = await instance.get(`/download/first/list`);
        result.mainCate = mainCate;

        const cid = query.cid ? query.cid : mainCate[0].cid;

        const selectedCate = mainCate.find((el) => +el.cid === +cid);

        if (selectedCate) {
            result.selectedCate = selectedCate;
            const {
                data: { list: subCate },
            } = await instance.get(`/download/second/list?cid=${selectedCate.cid}`);
            result.subCate = subCate;
        } else {
            const {
                data: { list: subCate },
            } = await instance.get(`/download/second/depthList?cid=${cid}`);
            result.subCate = subCate;
            result.selectedCate = subCate.find((el) => +el.cid === +cid);
        }

        return result;
    } catch (err) {
        return null;
    }
};

export const getFaqCategory = async (query) => {
    const result = {};
    const { cid = 32 } = query;

    const {
        data: { list: mainCate },
    } = await instance.get(`/faq/first/list`);
    result.mainCate = mainCate;

    const selectedCate = mainCate.find((el) => +el.cid === +cid);

    if (selectedCate) {
        result.selectedCate = selectedCate;
        const {
            data: { list: subCate },
        } = await instance.get(`/faq/second/list?cid=${selectedCate.cid}`);
        result.subCate = subCate;
    } else {
        const {
            data: { list: subCate },
        } = await instance.get(`/faq/second/depthList?cid=${cid}`);
        result.subCate = subCate;
        result.selectedCate = subCate.find((el) => +el.cid === +cid);
    }

    return result;
};

export const getDownloadList = async (query) => {
    const endPoint = `download/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return {
            paging: { list: [] },
        };
    }
};

export const getDownloadDetail = async (idx, pwd, query) => {
    const endPoint = `download/detail`;
    try {
        const result = await instance.post(endPoint, { idx, password: pwd, ...query });
        return result;
    } catch (err) {
        console.log(err)
        return [];
    }
};

export const getFaqList = async (query) => {
    const endPoint = `faq/list`;
    const queryString = createaQueryString(query);

    try {
        const result = await instance.get(endPoint + queryString);
        return result.data;
    } catch (err) {
        return [];
    }
};

export const checkDownloadDetail = async (query) => {
    try {
        const listData = await instance.post(`/download/detail`, query);
        return listData.data;
    } catch (err) {
        return { err };
    }
};

export const getProduct = async (type, query) => {
    const endPoint = `${type}/list`;
    const queryString = createaQueryString(query);

    try {
        return await instance.get(endPoint + queryString);
    } catch (err) {
        return [];
    }
};

export const getProductDetail = async (idx) => {
    const endPoint = `product/detail`;
    try {
        const result = await instance.post(endPoint, { idx });
        return result;
    } catch (err) {
        return [];
    }
};

export const getPostDetail = async (endPoint, idx, query) => {
    try {
        const result = await instance.post(endPoint, { idx, ...query });
        return result;
    } catch (err) {
        console.log(err)
        return [];
    }
};

export const getStockInfo = async () => {
    try {
        const result = await instance.get('/ir/getStockInfo');
        return result;
    } catch (err) {
        return [];
    }
};

export const getDartData = async () => {
    try {
        const result = await instance.get('/ir/getDartData');
        return result;
    } catch (err) {
        return [];
    }
};

export const getFssData = async (query) => {
    const endPoint = `ir/getFssData`;
    const queryString = createaQueryString(query);

    try {
        return await instance.get(endPoint + queryString);
    } catch (err) {
        return [];
    }
};

export const getStockholder = async (query) => {
    const endPoint = `stockholder/list`;
    const queryString = createaQueryString(query);

    try {
        return await instance.get(endPoint + queryString);
    } catch (err) {
        return [];
    }
};

export const getStockholdertDetail = async (idx) => {
    try {
        const result = await instance.post(`stockholder/detail`, { idx });
        return result;
    } catch (err) {
        return [];
    }
};

export const getAgnInfo = async (data) => {
    try {
        const result = await instance.post(`/voc/getAgnInfo`, data);
        return result;
    } catch (err) {
        return { data: { resultCode: '4444', msg: err } };
    }
};

export const vocCateList = async () => {
    try {
        const result = await instance.get(`/voc/cateList`);
        return result;
    } catch (err) {
        return {
            data: [
                {
                    cid: 1,
                    name: 'AS문의',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:11:31.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'Y',
                    list: [
                        {
                            cid: 10,
                            name: '전원안켜짐',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 11,
                            name: '액정화면 깨짐/깜빡임',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 12,
                            name: '카드인식불량(MS,IC)',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 13,
                            name: 'NFC/바코드불량',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 14,
                            name: '단말기(프린터)인쇄',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 15,
                            name: '단말기버튼작동관련',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 16,
                            name: '통신 및 기기연동관련',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 17,
                            name: '기타증상',
                            rootCid: 1,
                            depth: 2,
                            regDt: '2025-01-10T05:15:16.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 2,
                    name: '이지포스기능',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:11:43.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'Y',
                    list: [
                        {
                            cid: 18,
                            name: '프로그램 사용문의',
                            rootCid: 2,
                            depth: 2,
                            regDt: '2025-01-10T05:16:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 19,
                            name: '전원 안켜짐',
                            rootCid: 2,
                            depth: 2,
                            regDt: '2025-01-10T05:16:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 20,
                            name: '액정화면 깨짐/깜빡임',
                            rootCid: 2,
                            depth: 2,
                            regDt: '2025-01-10T05:16:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 21,
                            name: '장비일반(듀얼모니터)',
                            rootCid: 2,
                            depth: 2,
                            regDt: '2025-01-10T05:16:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 22,
                            name: '장비일반(주방프린터)',
                            rootCid: 2,
                            depth: 2,
                            regDt: '2025-01-10T05:16:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 23,
                            name: '기타증상',
                            rootCid: 2,
                            depth: 2,
                            regDt: '2025-01-10T05:16:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 3,
                    name: '단말기 기능(이지체크)',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:12:03.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'Y',
                    list: [
                        {
                            cid: 24,
                            name: '일정산',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 25,
                            name: '현금영수증 발급',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 26,
                            name: '신용승인',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 27,
                            name: '신용취소',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 28,
                            name: '현금영수증 취소',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 29,
                            name: '부가세참조자료',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 30,
                            name: '기타증상',
                            rootCid: 3,
                            depth: 2,
                            regDt: '2025-01-10T05:18:20.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 4,
                    name: '매출전표',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:12:09.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'Y',
                    list: [
                        {
                            cid: 31,
                            name: '전표용지요청',
                            rootCid: 4,
                            depth: 2,
                            regDt: '2025-01-10T05:18:40.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 5,
                    name: '부가서비스',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:12:15.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'N',
                    list: [
                        {
                            cid: 32,
                            name: '외국인관광객 세금환급 (Tax Refund)서비스',
                            rootCid: 5,
                            depth: 2,
                            regDt: '2025-01-10T05:20:35.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 33,
                            name: '중국인 알리페이결제(Alipay)서비스',
                            rootCid: 5,
                            depth: 2,
                            regDt: '2025-01-10T05:20:35.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 34,
                            name: '중국인 위챗페이결제(Wiechatpay)서비스',
                            rootCid: 5,
                            depth: 2,
                            regDt: '2025-01-10T05:20:35.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 35,
                            name: '대만인 라인페이결제(Linepay)서비스 ',
                            rootCid: 5,
                            depth: 2,
                            regDt: '2025-01-10T05:20:35.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 6,
                    name: '신규문의',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:12:21.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'N',
                    list: [
                        {
                            cid: 36,
                            name: '대리점 신규개설',
                            rootCid: 6,
                            depth: 2,
                            regDt: '2025-01-10T05:21:21.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 37,
                            name: '신규단말기설치문의',
                            rootCid: 6,
                            depth: 2,
                            regDt: '2025-01-10T05:21:21.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 38,
                            name: '프로그램 제휴 문의',
                            rootCid: 6,
                            depth: 2,
                            regDt: '2025-01-10T05:21:21.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 7,
                    name: '이지체크 모바일',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:12:30.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'Y',
                    list: [
                        {
                            cid: 39,
                            name: '리더기인식불가',
                            rootCid: 7,
                            depth: 2,
                            regDt: '2025-01-10T05:21:58.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 40,
                            name: '앱이용관련',
                            rootCid: 7,
                            depth: 2,
                            regDt: '2025-01-10T05:21:58.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 41,
                            name: '기기이용불가',
                            rootCid: 7,
                            depth: 2,
                            regDt: '2025-01-10T05:21:58.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 42,
                            name: 'TID관련',
                            rootCid: 7,
                            depth: 2,
                            regDt: '2025-01-10T05:21:58.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 43,
                            name: '전표전송',
                            rootCid: 7,
                            depth: 2,
                            regDt: '2025-01-10T05:21:58.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                        {
                            cid: 44,
                            name: '기타증상',
                            rootCid: 7,
                            depth: 2,
                            regDt: '2025-01-10T05:21:58.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [],
                        },
                    ],
                },
                {
                    cid: 8,
                    name: '이지페이',
                    rootCid: null,
                    depth: 1,
                    regDt: '2025-01-10T05:12:36.000+00:00',
                    activeYn: 'Y',
                    email: 'voc@kicc.co.kr',
                    agnInfoYn: 'N',
                    list: [
                        {
                            cid: 45,
                            name: '결제오류문의',
                            rootCid: 8,
                            depth: 2,
                            regDt: '2025-01-10T05:22:41.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [
                                {
                                    cid: 54,
                                    name: '1644-2004 안내전화',
                                    rootCid: 45,
                                    depth: 3,
                                    regDt: '2025-01-10T05:25:34.000+00:00',
                                    activeYn: 'Y',
                                    email: null,
                                    agnInfoYn: null,
                                    list: null,
                                },
                            ],
                        },
                        {
                            cid: 46,
                            name: '계약진행조회',
                            rootCid: 8,
                            depth: 2,
                            regDt: '2025-01-10T05:22:41.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [
                                {
                                    cid: 55,
                                    name: '계약 진행 조회(https://www.easypay.co.kr/application/ApplyProgressAction.do)',
                                    rootCid: 46,
                                    depth: 3,
                                    regDt: '2025-01-10T05:25:34.000+00:00',
                                    activeYn: 'Y',
                                    email: null,
                                    agnInfoYn: null,
                                    list: null,
                                },
                            ],
                        },
                        {
                            cid: 47,
                            name: '인터넷사용처문의',
                            rootCid: 8,
                            depth: 2,
                            regDt: '2025-01-10T05:22:41.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [
                                {
                                    cid: 56,
                                    name: '결제내역조회(https://www.easypay.co.kr/common/TradeCardAction.do)',
                                    rootCid: 47,
                                    depth: 3,
                                    regDt: '2025-01-10T05:25:34.000+00:00',
                                    activeYn: 'Y',
                                    email: null,
                                    agnInfoYn: null,
                                    list: null,
                                },
                            ],
                        },
                        {
                            cid: 48,
                            name: '신규문의',
                            rootCid: 8,
                            depth: 2,
                            regDt: '2025-01-10T05:22:41.000+00:00',
                            activeYn: 'Y',
                            email: null,
                            agnInfoYn: null,
                            list: [
                                {
                                    cid: 57,
                                    name: 'PG 신규 서비스 신청(https://www.easypay.co.kr/application/ApplyIntroAction.do',
                                    rootCid: 48,
                                    depth: 3,
                                    regDt: '2025-01-10T05:25:34.000+00:00',
                                    activeYn: 'Y',
                                    email: null,
                                    agnInfoYn: null,
                                    list: null,
                                },
                            ],
                        },
                    ],
                },
                // {
                //     cid: 9,
                //     name: '정보/기타문의',
                //     rootCid: null,
                //     depth: 1,
                //     regDt: '2025-01-10T05:12:42.000+00:00',
                //     activeYn: 'Y',
                //     email: 'voc@kicc.co.kr',
                //     agnInfoYn: 'Y',
                //     list: [
                //         {
                //             cid: 49,
                //             name: '단말기 명의변경 요청',
                //             rootCid: 9,
                //             depth: 2,
                //             regDt: '2025-01-10T05:23:32.000+00:00',
                //             activeYn: 'Y',
                //             email: null,
                //             agnInfoYn: null,
                //             list: [],
                //         },
                //         {
                //             cid: 50,
                //             name: '단말기 해지문의',
                //             rootCid: 9,
                //             depth: 2,
                //             regDt: '2025-01-10T05:23:32.000+00:00',
                //             activeYn: 'Y',
                //             email: null,
                //             agnInfoYn: null,
                //             list: [],
                //         },
                //         {
                //             cid: 51,
                //             name: '대리점연락처문의',
                //             rootCid: 9,
                //             depth: 2,
                //             regDt: '2025-01-10T05:23:32.000+00:00',
                //             activeYn: 'Y',
                //             email: null,
                //             agnInfoYn: null,
                //             list: [],
                //         },
                //         {
                //             cid: 52,
                //             name: '가맹점정보변경',
                //             rootCid: 9,
                //             depth: 2,
                //             regDt: '2025-01-10T05:23:32.000+00:00',
                //             activeYn: 'Y',
                //             email: null,
                //             agnInfoYn: null,
                //             list: [],
                //         },
                //         {
                //             cid: 53,
                //             name: '기타변경/기타사항',
                //             rootCid: 9,
                //             depth: 2,
                //             regDt: '2025-01-10T05:23:32.000+00:00',
                //             activeYn: 'Y',
                //             email: null,
                //             agnInfoYn: null,
                //             list: [],
                //         },
                //     ],
                // },
            ],
        };
    }
};

export const vocInsert = async (data) => {
    try {
        const result = await instance.post(`/voc/insertAction`, data);
        return result;
    } catch (err) {
        return { err };
    }
};

export const inquiryInsert = async (data) => {
    try {
        const result = await instance.post(`/inquiry/insertAction`, data);
        return result;
    } catch (err) {
        return { err };
    }
};

export const getCurriculumInfo = async () => {
    try {
        const result = await instance.get(`/curriculum/info`);
        return result;
    } catch (err) {
        return { err };
    }
};

export const resumeInsertAction = async (data) => {
    try {
        const result = await instance.post(`/resume/insertAction`, data);
        return result;
    } catch (err) {
        return { err };
    }
};

export const resumeUpdate = async (data) => {
    try {
        const result = await instance.post(`/resume/update`, data);
        return result;
    } catch (err) {
        return { err };
    }
};

export const getResumeDetail = async (idx) => {
    const endPoint = `recruit/detail`;

    try {
        return await instance.post(endPoint, { idx });
    } catch (err) {
        return { err };
    }
};

export const resumeCancel = async (idx) => {
    const endPoint = `resume/resumeCancel`;

    try {
        return await instance.post(endPoint, { idx });
    } catch (err) {
        return [];
    }
};
export const resumeList = async (query) => {
    const endPoint = `resume/list`;

    try {
        return await instance.get(endPoint, {
            params: query,
        });
    } catch (err) {
        return [];
    }
};

export const resumeDetail = async (idx, name) => {
    const endPoint = `resume/detail`;

    try {
        const payload = { idx };
        if (name) payload.name = name;
        return await instance.post(endPoint, payload);
    } catch (err) {
        return [];
    }
};

// report JSON과 첨부파일을 multipart/form-data로 함께 전송합니다.
export const postReport = async (report, files = []) => {
    const formData = new FormData();
    formData.append('report', JSON.stringify(report));
    files.slice(0, 3).forEach((file) => formData.append('files', file));
    const result = await instance.post('reports', formData);
    return result.data;
};
